import { useActivitySettings, usePlatformSettings, useRooms } from '../../queries';
import { ActivityOverridesPanel } from '../ActivityOverridesPanel';
import { ActivityRetentionPanel } from '../ActivityRetentionPanel';
import { PlatformSettingsPanel } from '../PlatformSettingsPanel';
import { SignInRemovalsPanel } from '../SignInRemovalsPanel';
import { AreaGate } from './AreaGate';

export function SettingsArea() {
  const settings = usePlatformSettings();
  const activity = useActivitySettings();
  const rooms = useRooms();
  const data = settings.data;

  return (
    <AreaGate
      queries={[settings, activity, rooms]}
      loadingLabel="Loading settings…"
      errorMessage="Couldn't load the platform settings."
    >
      <div className="space-y-6">
        {data ? <PlatformSettingsPanel settings={data} /> : null}
        {activity.data && rooms.data ? (
          <>
            <ActivityRetentionPanel settings={activity.data} rooms={rooms.data} />
            <ActivityOverridesPanel settings={activity.data} rooms={rooms.data} />
          </>
        ) : null}
        {/* Its own query: a queue an administrator works through, not a setting the panels above edit. */}
        <SignInRemovalsPanel />
      </div>
    </AreaGate>
  );
}
